/**
 * Русский каталог копий для функции `auth` (вход, регистрация, проверка волшебной ссылки,
 * сброс / установка пароля). Ключи соответствуют 1:1 вызовам `t('auth.*')`
 * в `packages/@gamecodex/world-ui/src/features/auth/*`. Значения — это точные
 * оригинальные русские строки.
 */
export const authRu = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Главная Grymwyrd',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Продолжить через Google',
  'auth.oauth.continueWithDiscord': 'Продолжить через Discord',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': 'Вход в систему',
  'auth.verify.seoDescription': 'Проверка вашей ссылки входа в Grymwyrd.',
  'auth.verify.errorMissingToken':
    'В этой ссылке входа отсутствует токен. Запросите новую на странице входа.',
  'auth.verify.errorInvalidOrExpired':
    'Эта ссылка входа недействительна или истекла. Запросите новую на странице входа.',
  'auth.verify.confirming': 'Подтверждаем вход…',
  'auth.verify.signedInHeading': 'Вы вошли в систему',
  'auth.verify.signedInAsPrefix': 'Вошли как',
  'auth.verify.signedInAsSuffix': '. Направляем вас в ваше святилище…',
  'auth.verify.takingYouToSanctum': 'Направляем вас в ваше святилище…',
  'auth.verify.goNow': 'Перейти сейчас',
  'auth.verify.problemHeading': 'Проблема со ссылкой входа',
  'auth.verify.backToSignIn': 'Вернуться на вход',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': 'Введите ваш адрес электронной почты и запросите ссылку.',
  'auth.login.seoTitle': 'Переступи Порог',
  'auth.login.seoDescription': 'Войдите в Grymwyrd и вернитесь к вашей легенде в вечных сумерках.',
  'auth.login.eyebrow': 'Возвращайся, Странник',
  'auth.login.title': 'Переступи Порог',
  'auth.login.blurb': 'Назови себя и произнеси тайное слово, чтобы вернуться в вечные сумерки.',
  'auth.login.noPactYet': 'Еще нет договора?',
  'auth.login.forgeYourLegend': 'Создай свою легенду',
  'auth.login.emailLabel': 'Email',
  'auth.login.emailPlaceholder': 'you@grymwyrd.com',
  'auth.login.passwordLabel': 'Пароль',
  'auth.login.forgotPassword': 'Забыли пароль?',
  'auth.login.submitBusy': 'Переступаем…',
  'auth.login.submit': 'Войти',
  'auth.login.dividerOr': 'или',
  'auth.login.magicSentPrefix': 'Волшебная ссылка входа в пути',
  'auth.login.magicSentTo': 'на',
  'auth.login.magicSentSuffix': '. Проверьте почту.',
  'auth.login.emailMeSignInLink': 'Отправить мне ссылку входа',
  'auth.login.mockAuthPrefix': 'Dev проверка: любой email работает. Используйте',
  'auth.login.mockAuthOr': 'или',
  'auth.login.mockAuthSuffix': 'для расширенных ролей.',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': 'Выберите имя, под которым будет рассказываться ваша легенда.',
  'auth.register.errorEmailRequired': 'Email требуется для заключения договора.',
  'auth.register.errorEmailInvalid': 'Этот email выглядит неправильно.',
  'auth.register.errorPasswordTooShort': 'Ваше тайное слово должно быть минимум 8 символов.',
  'auth.register.errorMustBeAdult': 'Вам должно быть 13 лет или старше, чтобы играть в Grymwyrd.',
  'auth.register.errorMustAcceptTerms': 'Вы должны принять договор (условия), чтобы продолжить.',
  'auth.register.errorIncomplete': 'Некоторые пункты вашего договора заполнены неправильно. Смотрите ниже.',
  'auth.register.seoTitle': 'Начни Свою Историю',
  'auth.register.seoDescription':
    'Создайте аккаунт Grymwyrd, воплотите аватара и пусть ваша история станет каноном.',
  'auth.register.eyebrow': 'Исследуй Деревню Greywick',
  'auth.register.title': 'Начни Свою Историю',
  'auth.register.blurb': 'Вы пробуждаетесь из эфирных грез и открываете глаза…',
  'auth.register.alreadyBound': 'Уже связаны с вечностью?',
  'auth.register.loginToExisting': 'Войти в Существующий Аккаунт',
  'auth.register.displayNameLabel': 'Игровое имя',
  'auth.register.displayNamePlaceholder': 'Полый Рыцарь',
  'auth.register.displayNameHint': 'Это имя вашего публичного аватара и ваших вкладов.',
  'auth.register.emailLabel': 'Email',
  'auth.register.emailPlaceholder': 'you@grymwyrd.com',
  'auth.register.passwordLabel': 'Пароль',
  'auth.register.passwordPlaceholder': 'Минимум 8 символов',
  'auth.register.agreementsLegend': 'Согласия',
  'auth.register.adultConfirmPrefix': 'Я подтверждаю, что мне',
  'auth.register.adultConfirmEmphasis': '13 лет или больше',
  'auth.register.adultConfirmSuffix': '.',
  'auth.register.acceptPrefix': 'Я принимаю',
  'auth.register.termsOfThePact': 'Условия Договора',
  'auth.register.acceptSuffix': '.',
  'auth.register.submitBusy': 'Заключаем договор…',
  'auth.register.submit': 'Выступить',
  'auth.register.dividerOr': 'или',
  'auth.register.mockAuthNote': 'Dev проверка: регистрация сохраняется локально. Email не отправляется.',
  'auth.register.lastUpdated': 'Последнее обновление {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Введите email, привязанный к вашему договору.',
  'auth.reset.seoTitle': 'Сброс Пароля',
  'auth.reset.seoDescription':
    'Забыли пароль? Мы отправим одноразовую ссылку; кликните её, чтобы установить новый пароль.',
  'auth.reset.eyebrow': 'Потеряно Слово',
  'auth.reset.title': 'Сброс Пароля',
  'auth.reset.blurb':
    'Назовите свой email, и одноразовая ссылка будет отправлена в темноту. Следуйте ей назад, и вы установите новый пароль.',
  'auth.reset.rememberedAfterAll': 'Вспомнили после всего?',
  'auth.reset.loginToExisting': 'Войти в Существующий Аккаунт',
  'auth.reset.successMessage':
    'Если аккаунт существует для {email}, одноразовая ссылка отправлена. Откройте её, чтобы войти и установить новый пароль — проверьте почту и папку спама.',
  'auth.reset.sendToDifferentEmail': 'Отправить на другой email',
  'auth.reset.emailLabel': 'Email',
  'auth.reset.emailPlaceholder': 'you@grymwyrd.com',
  'auth.reset.submitBusy': 'Вызываем…',
  'auth.reset.submit': 'Отправить Ссылку Входа',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': 'Выберите пароль минимум из 8 символов.',
  'auth.setPassword.errorMismatch': 'Эти пароли не совпадают.',
  'auth.setPassword.seoTitle': 'Установить Пароль',
  'auth.setPassword.seoDescription': 'Выберите новый пароль для вашего аккаунта Grymwyrd.',
  'auth.setPassword.eyebrow': 'Заключить Договор',
  'auth.setPassword.title': 'Установить Новый Пароль',
  'auth.setPassword.blurb':
    'Вы вошли. Выберите новый пароль — вы сможете использовать его в следующий раз вместе с волшебной ссылкой.',
  'auth.setPassword.ratherNot': 'Предпочли бы не делать этого?',
  'auth.setPassword.skipForNow': 'Пропустить на время',
  'auth.setPassword.successMessage': 'Ваш пароль установлен. Направляем вас в ваше святилище…',
  'auth.setPassword.newPasswordLabel': 'Новый пароль',
  'auth.setPassword.newPasswordPlaceholder': 'Минимум 8 символов',
  'auth.setPassword.confirmPasswordLabel': 'Подтвердите пароль',
  'auth.setPassword.confirmPasswordPlaceholder': 'Введите снова',
  'auth.setPassword.submitBusy': 'Заключаем…',
  'auth.setPassword.submit': 'Сохранить Пароль',
} as const
